import axios from "axios";
import {getToken} from "./TokenRepository";

const createConfig = () => {
    return {
        headers: {
            'Api-Key': `Bearer ${getToken()}`
        },
    };
}

export const getIpAccesses = async (userId, serviceId, search, page) => {
    const result = await axios.get(
        `${process.env.REACT_APP_API_URL}/ipAccess/search/${userId}/${serviceId}?search=${search}&page=${page}`, createConfig());
    return result.data;
}

export const getIpAccess = async (userId, serviceId, ipAddress) => {
    const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/ipAccess/${userId}/${serviceId}`,
        Object.assign({}, createConfig(), {data: ipAddress}));
    return response.data;
}

export const patchIpAccess = async (userId, serviceId, ipAddress, patch) => {
    const config = {
        ...createConfig(),
        headers: {
            ...createConfig().headers,
            'Content-Type': 'application/json-patch+json'
        }
    };
    const response = await axios.patch(
        `${process.env.REACT_APP_API_URL}/ipAccess/${userId}/${serviceId}?ipAddress=${ipAddress}`,
        patch,
        config
    );
    return response.data;
}
